export const FormGroup = ({ type, value, label, name, onChange, isRequired, placeholder }) => {
  return (
    <div className="form-group">
      <label className={`input-label ${isRequired ? "required" : ""}`}>
        {label}
      </label>
      <div className="input-cont">
        <input
          type={type}
          className="text-input"
          name={name}
          value={value}
          onChange={onChange}
          required={isRequired}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};
